import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import Link from "next/link";

const FunThingsAtHomeArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/fun-things-at-home`;

  return (
    <MainLayout>
      <NextSeo
        title='5 Fun Things To Do At Home | DAYMADE'
        description='Not sure how to spend your quarantine time now that the country is in lockdown? DAYMADE made a list of 5 fun things to do at home!'
        openGraph={{
          title: '5 Fun Things To Do At Home | DAYMADE',
          description: 'Not sure how to spend your quarantine time now that the country is in lockdown? DAYMADE made a list of 5 fun things to do at home!',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/5-fun-things-to-do-at-home',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'woman growing plants in home kitchen'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'quarantine, lockdown, things to do, fun, at home, gardening, cooking, foodies, crafts, crafting, knitting, corona, flowers, spa, rituals, cinema, netflix, goodee'
        // }]}
      />
      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText='woman growing plants in home kitchen'
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            5 Fun Things To Do <strong>At Home</strong>
          </h1>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>N</span>ow that most of us are under house-arrest, it has become a lot harder to live our bucket-lists. While future travels are still the most exciting thing to look forward to, we won't be jetsetting around the planet in the near term. But that doesn't mean that we can't try to make the most out of our quarantine! DAYMADE listed 5 fun things to do at home.
          </p>

          <h4>
            TRANSFORM YOUR LIVING ROOM INTO A <strong>CINEMA</strong>
          </h4>

          <p>
            Nobody gets particularly excited from spending a whole day watching Netflix in their bed. However, watching more films can certainly be a fun experience! Immersing yourself in your favourite film will be much easier with a home movie set, an old-fashioned projector and of course the key ingredient: popcorn! Get your house mates together for a movie night and grab the opportunity to finally watch those classics you've been wanting to see for ages. And whatever you do: make it a feel-good one!
          </p>

          <p>
            {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                Enter DAYMADE
              
            </Link>
            {''} to win a GooDee Upgraded 5800 Lumens Video Projector!
          </p>

          <h4>
            BECOME A FULL-TIME <strong>FLORIST</strong>
          </h4>

          <p>
            Have you got a case of green hands but never had the time to use them? Well, now is your time! Get into your landscape-architect mode, plant your favourite flowers and build your own kitchen garden -always handy in times of crisis and the subsequent empty supermarket shelves! As a former first lady once said, where flowers bloom, so does hope!
          </p>

          <p>
            Can't wait for your flowers and plants to grow? {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                Enter DAYMADE
              
            </Link>
            {''} to win a 6-months flower subscription to Bloom & Wild!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/hero.jpg`}
            alt='woman growing plants in home kitchen'
            className='singleBlogImage'
          />

          <h4>
            UNLEASH YOUR <strong>INNER CHEF</strong>
          </h4>

          <p>
            Are you used to coming home from work late and heating up some leftovers or settling for a Tesco meal deal because you can't be bothered to put a whole dinner together? There's no excuse now to not invest some TLC in your meals and if you were looking for inspiration, look no further: meal box providers like Gousto and HelloFresh have a wide variety of new recipes to try out. Their boxes come with all the measured ingredients (zero waste!), so all you have to do is follow the steps.
          </p>

          <p>
            Win a HelloFresh box (3 meals for 2 people) if you match 3 numbers, or win a masterclass from Gordon Ramsey - {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                enter here
              
            </Link>
            {''}.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt='couple cooking together in their home kichen'
            className='singleBlogImage'
          />

          <h4>
            GET <strong>CRAFTY</strong>
          </h4>

          <p>
            Curious whether there's a creative genius hidden inside of you? Test it out by learning a new craft! In these times, weaving, knitting, embroidering and crocheting are all the rage (who'd have known). Knit a scarf, paint a succulent planter kit, embroider an old vintage purse or learn calligraphy. You'd be opening your own Etsy store before you know it!
          </p>

          <p>
            {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                Enter DAYMADE
              
            </Link>
            {''} to win a MakeBox and learn a new craft!
          </p>

          <div className='doubleImageContainer'>
            <img
              src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
              alt='Art and crafts basket with scissors, needle, and lightly coloured thread'
              className='doubleBlogImage'
            />

            <img
              src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
              alt='Woman knitting some clothes with a cup of tea'
              className='doubleBlogImage'
            />
          </div>

          <h4>
            AN AT-HOME <strong>SPA BREAK</strong>
          </h4>

          <p>
            If anything requires a recharge, it's these hectic times. But alas, you can't visit a spa right now. Luckily, there's always the tools to bring the spa to your home. Stock up on face masks, massage oil, epsom salt, order a massage foot bath on Amazon and hit up the 'ocean sounds' playlist on Spotify. Zen times guaranteed!
          </p>

          <p>
            Match 3 numbers in the {''}
            <Link
              href='/enter?utm_source=blog-article'
              style={{ margin: 0, fontWeight: 'bold' }}>
              
                DAYMADE draw
              
            </Link>
            {''} to win a Rituals spa set!
          </p>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default FunThingsAtHomeArticle;
